import React from "react";
import styled from "./Resume.module.css";
const Resume = () => {
	return (
		<div id="resume">
			<h1 className={styled.mid}>Resume</h1>
			<div className={styled.flex} width="100%">
				<div className={styled.first}>
					<img
						className={styled.img}
						src="https://freepngimg.com/save/17604-resume-transparent/338x299"
						alt="cv"
						width="300px"
					/>
				</div>
				<div className={styled.second}>
					<a
						className={styled.img}
						href="https://drive.google.com/file/d/1Yc1rwwBo1ZomAeASV0POqhE3867KIK00/view?usp=share_link"
						download
						target="_blank"
						rel="noreferrer"
					>
						<button className={styled.btn}>View My Resume</button>
					</a>
				</div>
			</div>
		</div>
	);
};

export default Resume;
